<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<div class="col-md-12 form-group-inline mb-4" v-bind:class="{ 'is-invalid': errors.has('Tanggal Penyimpanan')}">
						<label class="col-form-label label-md col-md-3">Tanggal Penyimpanan</label>
						<div class="col-md-3">
							<input type="hidden" v-model="models.tglPenyimpanan" v-validate="'required'" data-vv-name="Tanggal Penyimpanan"/>
							<date-picker input-class="form-control" 
								v-model="models.tglPenyimpanan" 
								:editable="false" 
								:clearable="false" 
								format="YYYY-MM-DD" 
								:disabled-date="disabledDate"
								valueType="format"></date-picker>
							<div v-if="errors.has('Tanggal Penyimpanan')">
								<p class="text-danger mb-0">{{ errors.first('Tanggal Penyimpanan') }}</p>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Lokasi Wajib Retribusi</label>
						<div class="col-md-9">
							<b-form-group label="Kota">
								<select v-model="models.kotaSumberId" :disabled="config.disabled.kota" v-validate="'required'" @change="getDistrictByCity('Sumber', true)" data-vv-name="Kota Sumber"
								class="form-control">
									<option value="">Pilih Kota</option>
									<option v-for="(v,i) in masters.cities" :value="v.id" :key="i">
										{{v.namaKota}}
									</option>
								</select>
								<div v-if="errors.has('Kota Sumber')">
									<p class="text-danger mb-0">{{ errors.first('Kota Sumber') }}</p>
								</div>
							</b-form-group>
							<b-form-group label="Kecamatan">
								<select v-model="models.kecamatanSumberId" :disabled="config.disabled.kecamatan" v-validate="'required'" @change="getVillageByDistrict('Sumber', true)" data-vv-name="Kecamatan Sumber"
								class="form-control">
									<option value="">Pilih Kecamatan</option>
									<option v-for="(v,i) in masters.districtSumber" :value="v.id" :key="i">
										{{v.namaKecamatan}}
									</option>
								</select>
								<div v-if="errors.has('Kecamatan Sumber')">
									<p class="text-danger mb-0">{{ errors.first('Kecamatan Sumber') }}</p>
								</div>
							</b-form-group>
							<b-form-group label="Kelurahan">
								<select v-model="models.kelurahanSumberId" v-validate="'required'" @change="getUMK(true)" data-vv-name="Kelurahan Sumber"
								class="form-control">
									<option value="">Pilih Kelurahan</option>
									<option v-for="(v,i) in masters.villageSumber" :value="v.id" :key="i">
										{{v.namaKelurahan}}
									</option>
								</select>
								<div v-if="errors.has('Kelurahan Sumber')">
									<p class="text-danger mb-0">{{ errors.first('Kelurahan Sumber') }}</p>
								</div>
							</b-form-group>
							<b-form-group label="Jenis Usaha">
								<select v-model="models.jnsUsahaId" v-validate="'required'" @change="getUMK(true)" data-vv-name="Jenis Usaha"
								class="form-control">
									<option value="">Pilih Jenis Usaha</option>
									<option v-for="(v,i) in masters.jenisUsahaUMK" :value="v.id" :key="i">
										{{v.namaJenisUsaha}}
									</option>
								</select>
								<div v-if="errors.has('Jenis Usaha')">
									<p class="text-danger mb-0">{{ errors.first('Jenis Usaha') }}</p>
								</div>
							</b-form-group>
							<b-form-group label="Nama UMK">
								<select v-model="models.umkId" @change="getDetailUmk()" v-validate="'required'" data-vv-name="Nama UMK"
									class="form-control">
									<option value="">Pilih UMK</option>
									<option v-for="(v,i) in masters.umk" :value="v.id" :key="i">
										{{v.kodeWR}} - {{v.namaUMK}}
									</option>
								</select>
								<div v-if="errors.has('Nama UMK')">
									<p class="text-danger mb-0">{{ errors.first('Nama UMK') }}</p>
								</div>
							</b-form-group>
							<b-form-group v-if="models.umkId" label="Alamat Lengkap">
								{{ models.umk ? models.umk.alamat : "" }}
							</b-form-group>
						</div>
					</div>
					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Jenis Sampah B3(Kg)</label>
						<div class="col-md-9">
							<b-form-group class="col-md-6" label="Sisa Produk Mengandung B3">
								<b-input-group class="mt-3">
									<template #append>
										<b-input-group-text><strong>Kg</strong></b-input-group-text>
									</template>
									<b-form-input type="number" step="any" @change="convertToNumber('sisaProdukMengandungB3')" v-model="models.sisaProdukMengandungB3" v-validate="'required'" data-vv-name="Sisa Produk Mengandung B3">
									</b-form-input>
								</b-input-group>
								<div v-if="errors.has('Sisa Produk Mengandung B3')">
									<p class="text-danger mb-0">{{ errors.first('Sisa Produk Mengandung B3') }}</p>
								</div>
							</b-form-group>
							<template>
								<p class="col-form-label fs-15px">Sampah Elektronik e-Waste</p>
								<b-row class="ml-1">
									<b-form-group class="col-md-6" label="Peralatan Pendingin Makanan & Penyejuk Udara">
										<b-input-group class="mt-3">
											<template #append>
												<b-input-group-text><strong>Kg</strong></b-input-group-text>
											</template>
											<b-form-input type="number" step="any" @change="convertToNumber('sampahEwastePendingin')" v-model="models.sampahEwastePendingin" v-validate="'required'" data-vv-name="Peralatan Pendingin Makanan & Penyejuk Udara">
											</b-form-input>
										</b-input-group>
										<div v-if="errors.has('Peralatan Pendingin Makanan & Penyejuk Udara')">
											<p class="text-danger mb-0">{{ errors.first('Peralatan Pendingin Makanan & Penyejuk Udara') }}</p>
										</div>
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Berukuran Besar">
										<b-input-group class="mt-3">
											<template #append>
												<b-input-group-text><strong>Kg</strong></b-input-group-text>
											</template>
											<b-form-input type="number" step="any" @change="convertToNumber('sampahEwasteBesar')" v-model="models.sampahEwasteBesar" v-validate="'required'" data-vv-name="Peralatan Berukuran Besar">
											</b-form-input>
										</b-input-group>
										<div v-if="errors.has('Peralatan Berukuran Besar')">
											<p class="text-danger mb-0">{{ errors.first('Peralatan Berukuran Besar') }}</p>
										</div>
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Berukuran Kecil">
										<b-input-group class="mt-3">
											<template #append>
												<b-input-group-text><strong>Kg</strong></b-input-group-text>
											</template>
											<b-form-input type="number" step="any" @change="convertToNumber('sampahEwasteKecil')" v-model="models.sampahEwasteKecil" v-validate="'required'" data-vv-name="Peralatan Berukuran Kecil">
											</b-form-input>
										</b-input-group>
										<div v-if="errors.has('Peralatan Berukuran Kecil')">
											<p class="text-danger mb-0">{{ errors.first('Peralatan Berukuran Kecil') }}</p>
										</div>
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Komunikasi, Teknologi Informasi dan Layar Monitor">
										<b-input-group class="mt-3">
											<template #append>
												<b-input-group-text><strong>Kg</strong></b-input-group-text>
											</template>
											<b-form-input type="number" step="any" @change="convertToNumber('sampahEwasteKomunikasiTi')" v-model="models.sampahEwasteKomunikasiTi" v-validate="'required'" data-vv-name="Peralatan Komunikasi, Teknologi Informasi dan Layar Monitor">
											</b-form-input>
										</b-input-group>
										<div v-if="errors.has('Peralatan Komunikasi, Teknologi Informasi dan Layar Monitor')">
											<p class="text-danger mb-0">{{ errors.first('Peralatan Komunikasi, Teknologi Informasi dan Layar Monitor') }}</p>
										</div>
									</b-form-group>
									<b-form-group class="col-md-6" label="Peralatan Pencahayaan">
										<b-input-group class="mt-3">
											<template #append>
												<b-input-group-text><strong>Kg</strong></b-input-group-text>
											</template>
											<b-form-input type="number" step="any" @change="convertToNumber('sampahEwastePencahayaan')" v-model="models.sampahEwastePencahayaan" v-validate="'required'" data-vv-name="Peralatan Pencahayaan">
											</b-form-input>
										</b-input-group>
										<div v-if="errors.has('Peralatan Pencahayaan')">
											<p class="text-danger mb-0">{{ errors.first('Peralatan Pencahayaan') }}</p>
										</div>
									</b-form-group>
								</b-row>
							</template>

							<p class="col-form-label fs-15px">Sampah Kemasan B3</p>
							<b-row class="ml-1">
								<b-form-group class="col-md-6" label="Kemasan Kaleng">
									<b-input-group class="mt-3">
										<template #append>
											<b-input-group-text><strong>Kg</strong></b-input-group-text>
										</template>
										<b-form-input type="number" step="any" @change="convertToNumber('sampahKemasanKaleng')" v-model="models.sampahKemasanKaleng" v-validate="'required'" data-vv-name="Kemasan Kaleng">
										</b-form-input>
									</b-input-group>
									<div v-if="errors.has('Kemasan Kaleng')">
										<p class="text-danger mb-0">{{ errors.first('Kemasan Kaleng') }}</p>
									</div>
								</b-form-group>
								<b-form-group class="col-md-6" label="Kemasan Plastik">
									<b-input-group class="mt-3">
										<template #append>
											<b-input-group-text><strong>Kg</strong></b-input-group-text>
										</template>
										<b-form-input type="number" step="any" @change="convertToNumber('sampahKemasanPlastik')" v-model="models.sampahKemasanPlastik" v-validate="'required'" data-vv-name="Kemasan Plastik">
										</b-form-input>
									</b-input-group>
									<div v-if="errors.has('Kemasan Plastik')">
										<p class="text-danger mb-0">{{ errors.first('Kemasan Plastik') }}</p>
									</div>
								</b-form-group>
							</b-row>
							<p class="col-form-label fs-15px">Sampah Lainnya</p>
							<b-row class="ml-1">
								<b-form-group class="col-md-6" label="Sampah Medis">
									<b-input-group class="mt-3">
										<template #append>
											<b-input-group-text><strong>Kg</strong></b-input-group-text>
										</template>
										<b-form-input type="number" step="any" @change="convertToNumber('sampahMedis')" v-model="models.sampahMedis" v-validate="'required'" data-vv-name="Sampah Medis">
										</b-form-input>
									</b-input-group>
									<div v-if="errors.has('Sampah Medis')">
										<p class="text-danger mb-0">{{ errors.first('Sampah Medis') }}</p>
									</div>
								</b-form-group>
								<b-form-group class="col-md-6" label="Battery Aki Bekas">
									<b-input-group class="mt-3">
										<template #append>
											<b-input-group-text><strong>Kg</strong></b-input-group-text>
										</template>
										<b-form-input type="number" step="any" @change="convertToNumber('batteryAkiBekas')" v-model="models.batteryAkiBekas" v-validate="'required'" data-vv-name="Battery Aki Bekas">
										</b-form-input>
									</b-input-group>
									<div v-if="errors.has('Battery Aki Bekas')">
										<p class="text-danger mb-0">{{ errors.first('Battery Aki Bekas') }}</p>
									</div>
								</b-form-group>
								<b-form-group class="col-md-6" label="Kain Majun Terkontaminasi B3">
									<b-input-group class="mt-3">
										<template #append>
											<b-input-group-text><strong>Kg</strong></b-input-group-text>
										</template>
										<b-form-input type="number" step="any" @change="convertToNumber('kainMajunTerkontaminasiB3')" v-model="models.kainMajunTerkontaminasiB3" v-validate="'required'" data-vv-name="Kain Majun Terkontaminasi B3">
										</b-form-input>
									</b-input-group>
									<div v-if="errors.has('Kain Majun Terkontaminasi B3')">
										<p class="text-danger mb-0">{{ errors.first('Kain Majun Terkontaminasi B3') }}</p>
									</div>
								</b-form-group>
								<b-form-group class="col-md-6" label="Oli Bekas">
									<b-input-group class="mt-3">
										<template #append>
											<b-input-group-text><strong>Kg</strong></b-input-group-text>
										</template>
										<b-form-input type="number" step="any" @change="convertToNumber('oliBekas')" v-model="models.oliBekas" v-validate="'required'" data-vv-name="Oli Bekas">
										</b-form-input>
									</b-input-group>
									<div v-if="errors.has('Oli Bekas')">
										<p class="text-danger mb-0">{{ errors.first('Oli Bekas') }}</p>
									</div>
								</b-form-group>
							</b-row>
						</div>
					</div>
					<div class="col-md-12 form-group-inline align-items-start">
						<label class="col-form-label label-md col-md-3">Tujuan Lokasi Penyimpanan (Skala Kota / Kecamatan)</label>
						<div class="col-md-9">
							<b-form-group label="Wilayah">
								<div class="col-sm-12 no-padding">
									<label class="radio-inline no-padding">
										<input type="radio" v-model="models.skala" @click="models.jnsFasilitasTujuan = '6'" value="kecamatan">
										<span>Kecamatan</span>
									</label>
									<label class="radio-inline">
										<input type="radio" v-model="models.skala" @click="models.jnsFasilitasTujuan = '5'; models.kecamatanTujuanId = ''" value="kota">
										<span>Kota</span>
									</label>
								</div>
							</b-form-group>
							<b-form-group label="Kota">
								<select v-model="models.kotaTujuanId" :disabled="config.disabled.kota" v-validate="'required'" @change="getDistrictByCity('Tujuan', true)" data-vv-name="Kota Tujuan"
								class="form-control">
									<option value="">Pilih Kota</option>
									<option v-for="(v,i) in masters.cities" :value="v.id" :key="i">
										{{v.namaKota}}
									</option>
								</select>
								<div v-if="errors.has('Kota Tujuan')">
									<p class="text-danger mb-0">{{ errors.first('Kota Tujuan') }}</p>
								</div>
							</b-form-group>
							<b-form-group v-if="models.skala == 'kecamatan'" label="Kecamatan">
								<select v-model="models.kecamatanTujuanId" :disabled="config.disabled.kecamatan" v-validate="'required'" @change="getFasilitasB3('Tujuan', true)" data-vv-name="Kecamatan Tujuan"
								class="form-control">
									<option value="">Pilih Kecamatan</option>
									<option v-for="(v,i) in masters.districtTujuan" :value="v.id" :key="i">
										{{v.namaKecamatan}}
									</option>
								</select>
								<div v-if="errors.has('Kecamatan Tujuan')">
									<p class="text-danger mb-0">{{ errors.first('Kecamatan Tujuan') }}</p>
								</div>
							</b-form-group>
							<b-form-group label="Jenis Fasilitas">
								<div class="col-sm-12 no-padding">
									<label v-if="models.skala == 'kecamatan'" class="radio-inline">
										<input type="radio" v-model="models.jnsFasilitasTujuan" value="6">
										<span>FPSSB3 KECAMATAN</span>
									</label>
									<label v-if="models.skala == 'kota'" class="radio-inline no-padding">
										<input type="radio" v-model="models.jnsFasilitasTujuan" value="5">
										<span>FPSSB3 KOTA</span>
									</label>
									<label class="radio-inline">
										<input type="radio" v-model="models.jnsFasilitasTujuan" value="7">
										<span>COLLECTION POINT</span>
									</label>
									<input type="hidden" v-model="models.jnsFasilitasTujuan" v-validate="'required'" data-vv-name="Jenis Fasilitas Tujuan"/>
									<div v-if="errors.has('Jenis Fasilitas Tujuan')">
										<p class="text-danger mb-0">{{ errors.first('Jenis Fasilitas Tujuan') }}</p>
									</div>
								</div>
							</b-form-group>
							<b-form-group label="Fasilitas B3 Tujuan">
								<select v-model="models.fasilitasTujuanId" @change="getDetailFasilitasB3('Tujuan')" v-validate="'required'" data-vv-name="Fasilitas B3 Tujuan"
									class="form-control">
									<option value="">Pilih Fasilitas B3</option>
									<option v-for="(v,i) in masters.fasilitasTujuan" :value="v.id" :key="i">
										{{v.namaFasilitas}}
									</option>
								</select>
								<div v-if="errors.has('Fasilitas B3 Tujuan')">
									<p class="text-danger mb-0">{{ errors.first('Fasilitas B3 Tujuan') }}</p>
								</div>
							</b-form-group>
							<b-form-group v-if="models.fasilitasTujuanId" label="Alamat Fasilitas B3">
								{{ models.fasilitasTujuan ? models.fasilitasTujuan.alamatFasilitas : "" }}
							</b-form-group>
						</div>
					</div>
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width float-right">
						Simpan
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import moment from 'moment';
	import DatePicker from 'vue2-datepicker';
  	import 'vue2-datepicker/index.css';

	export default {
		name: 'FormB3UMKLevel1',
		components: {
			ResponseAlert,
			DatePicker
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
					disabled: {
						kota: false,
						kecamatan: false,
					}
				},
				models: {
					kotaSumberId: "",
					kecamatanSumberId: "",
					kelurahanSumberId: "",
					jnsUsahaId: "",
					umkId: "",
					umk: {},
					sisaProdukMengandungB3: 0,
					sampahEwastePendingin: 0,
					sampahEwasteBesar: 0,
					sampahEwasteKecil: 0,
					sampahEwasteKomunikasiTi: 0,
					sampahEwastePencahayaan: 0,
					sampahKemasanKaleng: 0,
					sampahKemasanPlastik: 0,
					sampahMedis: 0,
					batteryAkiBekas: 0,
					kainMajunTerkontaminasiB3: 0,
					isVerified: "0",
					pickupStatus: "0",
					oliBekas: 0,
					jnsFasilitasTujuan: "",
					skala: "kecamatan",
					kotaTujuanId: "",
					kecamatanTujuanId: "",
					fasilitasTujuanId: "",
					fasilitasTujuan: {},
					tglPenyimpanan: moment().format('YYYY-MM-DD'),
				},
				masters: {
					cities: [],
					districtSumber: [],
					districtTujuan: [],
					villageSumber: [],
					jenisUsahaUMK: [],
					umk: [],
					fasilitasTujuan: [],
				},
			}
		},
		created() {
			const _ = this
			_.getById();
			_.getCities();
			_.getJenisUsaha();
			_.getUser();
		},
		methods: {
			disabledDate: function (date) {
				// const now = moment();
				// if(now.format('DD') >= 7){
				// 	return date < moment();
				// }
			},

			async getUser() {
				const _ = this;
				const request = await _.$axios.get(`Authentication/me`);
				if(request){
					let user = request.data.data;
					if(user.kota){
						if (!_.$route.params.id) {
							_.models.kotaSumberId = user.kota.id;
							_.models.kotaTujuanId = user.kota.id;
							_.getDistrictByCity('Sumber', false);
							_.getDistrictByCity('Tujuan', false);
						}
						_.config.disabled.kota = true;
					}

					if(user.kecamatan){
						if (!_.$route.params.id) {
							_.models.kecamatanSumberId = user.kecamatan.id;
							_.models.kecamatanTujuanId = user.kecamatan.id;
							_.getVillageByDistrict('Sumber', false);
						}
						_.config.disabled.kecamatan = true;
					}
				}
			},
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`PenyimpananUsahaMikroKecil/${_.$route.params.id}`);
						const data = request.data.data;
						_.models.id = data.id;

						_.models.jnsUsahaId = data.umk ? data.umk.jenisUsahaUMKId : "";
						_.models.umkId = data.umkId;
						_.models.umk = data.umk;
						_.models.kotaSumberId = data.umk ? data.umk.kotaId : "";
						_.models.kecamatanSumberId = data.umk ? data.umk.kecamatanId : "";
						_.models.kelurahanSumberId = data.umk ? data.umk.kelurahanId : "";
						
						_.models.skala = (data.fasilitasTujuan && data.fasilitasTujuan.kecamatanId) ? 'kecamatan' : 'kota';
						_.models.jnsFasilitasTujuan = data.jnsFasilitasTujuan;
						_.models.fasilitasTujuan = data.fasilitasTujuan;
						_.models.fasilitasTujuanId = data.fasilitasTujuanId;
						_.models.kotaTujuanId = data.fasilitasTujuan ? data.fasilitasTujuan.kotaId : "";
						_.models.kecamatanTujuanId = data.fasilitasTujuan ? data.fasilitasTujuan.kecamatanId : "";
						
						_.models.tglPenyimpanan = data.tglPenyimpanan;
						_.models.sisaProdukMengandungB3 = data.sisaProdukMengandungB3;
						_.models.sampahEwastePendingin = data.sampahEwastePendingin;
						_.models.sampahEwasteBesar = data.sampahEwasteBesar;
						_.models.sampahEwasteKecil = data.sampahEwasteKecil;
						_.models.sampahEwasteKomunikasiTi = data.sampahEwasteKomunikasiTi;
						_.models.sampahEwastePencahayaan = data.sampahEwastePencahayaan;
						_.models.sampahKemasanKaleng = data.sampahKemasanKaleng;
						_.models.sampahKemasanPlastik = data.sampahKemasanPlastik;
						_.models.sampahMedis = data.sampahMedis;
						_.models.batteryAkiBekas = data.batteryAkiBekas;
						_.models.kainMajunTerkontaminasiB3 = data.kainMajunTerkontaminasiB3;
						_.models.oliBekas = data.oliBekas;
						_.models.pickupStatus = data.pickupStatus ? String(data.pickupStatus) : '0';
						_.getCities();
						_.getDistrictByCity('Sumber', false);
						_.getVillageByDistrict('Sumber', false);
						_.getDistrictByCity('Tujuan', false);
						_.getFasilitasB3('Tujuan', false);
						_.getJenisUsaha(false);
						_.getUMK(false);
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			getCities() {
				const _ = this
				_.$axios.get('Kota')
				.then(res => {
					_.masters.cities = res.data.data;
				});
			},
			getDistrictByCity(master, reset = true) {
				const _ = this;
				_.$axios.get('Kecamatan/ByKotaId/' + _.models[`kota${master}Id`])
				.then(res => {
					if(reset === true){
						_.models[`kecamatan${master}Id`] = '';
						_.models[`kelurahan${master}Id`] = '';
					}
					_.masters[`district${master}`] = res.data.data;
				});
			},
			getVillageByDistrict(master, reset = true) {
				const _ = this
				_.$axios.get('Kelurahan/ByKecamatanId/' + _.models[`kecamatan${master}Id`])
				.then(res => {
					if(reset === true){
						_.models[`kelurahan${master}Id`] = '';
					}
					_.masters[`village${master}`] = res.data.data;
				});
			},
			getJenisUsaha() {
				const _ = this
				_.$axios.get('JenisUsahaUMK')
				.then(res => {
					_.masters.jenisUsahaUMK = res.data.data;
				});
			},
			getUMK(reset) {
				const _ = this;
				const params = {};
				if(_.models.kotaSumberId){
					params.kotaId = _.models.kotaSumberId;
				}
				if(_.models.kecamatanSumberId){
					params.kecamatanId = _.models.kecamatanSumberId;
				}
				if(_.models.kelurahanSumberId){
					params.kelurahanId = _.models.kelurahanSumberId;
				}
				if(_.models.jnsUsahaId){
					params.jenisUsahaUMKId = _.models.jnsUsahaId;
				}
				_.$axios.get('UMK/filter', {
					params
				})
				.then(res => {
					if(reset == true){
						_.models.umkId = "";
					}
					_.masters.umk = res.data.data;
				});
			},
			getDetailUmk(){
				const _ = this;
				for(let i = 0; i < _.masters.umk.length; i++){
					if(_.masters.umk[i].id == _.models.umkId){
						_.models.umk = _.masters.umk[i];
						break;
					}
				}
			},
			getFasilitasB3(master, reset) {
				const _ = this
				const params = {};
				if(_.models[`kota${master}Id`]){
					params.KotaId = _.models[`kota${master}Id`];
				}
				if(_.models[`kecamatan${master}Id`]){
					params.KecamatanId = _.models[`kecamatan${master}Id`];
				}
				if(_.models[`kelurahan${master}Id`]){
					params.KelurahanId = _.models[`kelurahan${master}Id`];
				}
				if(_.models[`jnsFasilitas${master}`]){
					params.jenisFasilitas = _.models[`jnsFasilitas${master}`];
				}
				_.$axios.get('FasilitasB3TPS/byLocation',{ params })
				.then(res => {
					if(reset === true){
						_.models[`fasilitas${master}Id`]= '';
					}
					_.masters[`fasilitas${master}`] = res.data.data;
				});
			},
			getDetailFasilitasB3(master){
				const _ = this;
				const fasilitasId = _.models[`fasilitas${master}Id`];
				const source = _.masters[`fasilitas${master}`];
				_.models[`fasilitas${master}`] = {};
				for(let i = 0; i < source.length; i++){
					if(source[i].id == fasilitasId){
						_.models[`fasilitas${master}`] = source[i];
						break;
					}
				}
			},
			convertToNumber(key){
				this.models[key] = Number(this.models[key]);
			},
			save() {
				const _ = this;
				_.$validator.validate().then(valid => {
					if (valid) {
						let request = "";
						if (!_.$route.params.id) {
							request = _.$axios.post(`PenyimpananUsahaMikroKecil`, _.models);
						} else {
							request = _.$axios.put(`PenyimpananUsahaMikroKecil/${_.$route.params.id}`, _.models);
						}
						request
						.then(() => _.$router.push({
							name: _.config.uri
						}))
						.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
						
					} else {
						window.scrollTo(0, 0);
					}
				});
			},
		},

		watch:{
			'models.jnsFasilitasTujuan': {
				handler(newVal, oldVal) {
					this.getFasilitasB3('Tujuan', (oldVal != ''));
				},
				deep: true
			},
			'models.kotaTujuanId': {
				handler(newVal, oldVal) {
					this.getFasilitasB3('Tujuan', (oldVal != ''));
				},
				deep: true
			},
			'models.kecamatanTujuanId': {
				handler(newVal, oldVal) {
					this.getFasilitasB3('Tujuan', (oldVal != ''));
				},
				deep: true
			},
		}
	}
</script>